import { render, staticRenderFns } from "./union.vue?vue&type=template&id=0b5b9b61&scoped=true&"
import script from "./union.vue?vue&type=script&lang=js&"
export * from "./union.vue?vue&type=script&lang=js&"
import style0 from "./union.vue?vue&type=style&index=0&id=0b5b9b61&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5b9b61",
  null
  
)

export default component.exports